// extracted by mini-css-extract-plugin
export var activeDot = "_28-c";
export var buttonContainer = "_28-9";
export var channelButton = "_28-a";
export var clickable = "_28-d";
export var content = "_28-0";
export var contentFull = "_28-2";
export var contentThird = "_28-1";
export var contentWrapper = "_28-7";
export var description = "_28-5";
export var heightShort = "_28-f";
export var image = "_28-3";
export var imageContainer = "_28-4";
export var selectButton = "_28-e";
export var spinnerContainer = "_28-b";
export var titleContent = "_28-8";
export var titleWrapper = "_28-6";